export const trackContact = () => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "conversion", { send_to: "AW-18487340683/0sMQCIvvlasdEIvdue9E" });
  }
};
